import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import RadioButton from '../../Shared/RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "../../Shared/Select";
import styled, {css} from "styled-components";
import { Trans } from "../../utils/i18n";
import TextInput from "../../Shared/TextInput";
import {Button, FormControl, FormControlLabel, FormLabel, RadioGroup} from "@mui/material";
import {useMutation, useQuery} from "@tanstack/react-query";
import {Alert} from "@material-ui/lab";
import ErrorIcon from '@mui/icons-material/Error';
import Radio from "../../Shared/Radio";
import {useFormState, useFormStateDispatch} from "../FormState";
import i18n from "i18next";
import {getCookieValue} from "../../utils/getCookieValue";
import classNames from "classnames";
import TextField from "@mui/material/TextField";
import SingleQuestion from "./SingleQuestion";

export default function WorkflowQuestions ({ form, values, }) {
    const answers = values.workflow_questions || {};
    const { selectedProduct } = useFormState();

    const { data, isLoading } = useQuery({
        queryKey: ["workflowquestions.get", values.problem_2, selectedProduct?.id],
        queryFn: async () => {
            const res = await fetch(
                route("workflowquestions.get", {
                    problem_2: values.problem_2,
                    product_id: selectedProduct?.id || null,
                }),
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "X-XSRF-TOKEN": getCookieValue("XSRF-TOKEN"),
                        "X-Requested-With": "XMLHttpRequest",
                    },
                }
            );
            return await res.json();
        },
    });

    const firstQuestion = data?.data;

    useEffect(() => {
        if(!isLoading && !data?.data) {
            form.change(`workflow_questions`, null);
            form.change("workflow_questions_valid", true);
        }
        if(!isLoading && data?.data) {
            function nestedfind(question) {
                const answerText = answers[question.id] || null;
                if(!answerText) {
                    return null;
                }
                const selectedAnswer = question.answers.find((answer) => {
                    if(answer.regex) {
                        const strippedRegex = answer.regex ? answer.regex.replace(/^\/|\/$/g, '') : null;
                        const regexValid = strippedRegex ? (new RegExp(strippedRegex)) : null;
                        return regexValid.test(answerText);
                    }
                    return answer.title === answerText;
                });
                if(selectedAnswer && selectedAnswer.nextQuestion) {
                    const { question: recusiveFind } = nestedfind(selectedAnswer.nextQuestion) || {};
                    return recusiveFind ? recusiveFind : question;
                }
                return {
                    question,
                    answer: selectedAnswer,
                };
            }
            const { question: lastQuestion, answer} = nestedfind(firstQuestion) || {};
            if(lastQuestion?.nextQuestion || !lastQuestion || answer.action === "end_flow") {
                form.change("workflow_questions_valid", false);
            }
        }
    }, [isLoading, data?.data, values?.problem_2, values?.product_id]);

    if(isLoading) {
        return (
            <div>
                <h2>Workflow Questions</h2>
                <div>
                    <h3>
                        Loading...
                    </h3>
                </div>
            </div>
        );
    }

    if(!data?.data) {
        return null;
    }


    return (
        <div>
            <div>
                <SingleQuestion answers={answers} form={form} question={firstQuestion} />
            </div>
        </div>
    );
}
